<template>
  <div>

    <xolas-table
       table-ref="progress-table"

       :title="permitLabel"
       icon="fa fa-share-alt"

       :hide-org-badge="hideBadge"
       :show-search="showSearch"

       :url="'/actions/site/' + rowData.id + '/null/prg'"

       :fields="fields"

       :layer-component="'progress'"
       :layer-args="{ id: 'id' }">

      <template #progress-controls="props">
        <progress-controls :row-data="props.rowData" />
      </template>

    </xolas-table>

  </div>

</template>


<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import ProgressAction from '@/components/actions/ProgressAction'

import ProgressControls from '@/components/progress/ProgressControls'
import XolasTable from '@/components/atoms/tables/XolasTable'

import {settings} from '@/components/Data'

export default {

  mixins: [DateMixins, NumberMixins],


  components: {
    ProgressAction,
    ProgressControls,
    XolasTable
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    hideBadge: {
      type: Boolean,
      default: false
    },

    showSearch: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }


  },



  data () {

    return {

      telcoId: this.isTelco() ? Number(this.org().id) : null,
      permitLabel: settings.permitLabel,

      // Per-column widths so el-table doesn't bloat `#` and evenly-distribute the
      // rest (matches the legacy vuetable content-based layout — XOL-231 PR 5b).
      fields: [
        {
          name: 'actionType',
          title: 'Type',
          sortField: 'actionType',
          minWidth: '90'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '150'
        },
        {
          name: 'priority',
          title: 'Priority',
          sortField: 'priority',
          callback: this.formatPriority,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '100'
        },
        {
          name: 'organisation.shortName',
          title: 'Company',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '120'
        },
        {
          name: 'targetDate',
          title: 'Target Date',
          callback: 'formatDate|DD MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '130'
        },
        {
          name: '__slot:progress-controls',
          title: '',
          minWidth: '110'
        }

      ]
    }

  }

}

</script>
